import React, { useCallback } from 'react';

import { Paper } from '@mantine/core';
import PackageSummary from 'components/SalesPortal/PackageSummary';
import PurchaseConfirmation from 'components/SalesPortal/PurchaseConfirmation';
import { useNavigate } from 'react-router-dom';
import { SalesPortalPackageRetrieve } from 'types';

interface IConfirmationProps {
  packageData: SalesPortalPackageRetrieve;
  noPaymentTaken: boolean;
}

// The athlete-side portal's confirmation, on the shared component (spec Item 1). This
// flow is always a signed-in athlete with no pre-selected class, so it renders the
// "open the app" variant; My Schedule is the athlete app's root route.
const Confirmation = ({ packageData, noPaymentTaken }: IConfirmationProps): JSX.Element => {
  const navigate = useNavigate();

  const handleOpenSchedule = useCallback((): void => {
    navigate('/');
  }, [navigate]);

  return (
    <PurchaseConfirmation
      variant='hasApp'
      noPaymentTaken={noPaymentTaken}
      onOpenSchedule={handleOpenSchedule}
    >
      <Paper withBorder p='lg' shadow='md' w='100%' maw={560}>
        <PackageSummary pckg={packageData} />
      </Paper>
    </PurchaseConfirmation>
  );
};

export default Confirmation;
